export default __webpack_public_path__ + "static/media/bars_green_icon.0c46a397.svg";